import { CreativeOSFeatures } from '@/_shared/subscriptionPlans'

export const INSPIRATION_TABS = [
  {
    name: 'Ads',
    link: '/feeds/inspiration',
    featureName: CreativeOSFeatures.AD_INSPIRATION_NAV_BUTTON,
  },
  {
    name: 'Emails',
    link: '/feeds/inspiration/emails',
    featureName: CreativeOSFeatures.EMAIL_INSPIRATION_NAV_BUTTON,
  },
  {
    name: 'Landers',
    link: '/feeds/inspiration/landing-pages',
    featureName: CreativeOSFeatures.LANDER_INSPIRATION_NAV_BUTTON,
  },
]

export const REQUESTS_TABS = [
  {
    name: 'Ads',
    link: `/feeds/requested`,
  },
  {
    name: 'Emails',
    link: `/feeds/requested/emails`,
  },
  {
    name: 'Landers',
    link: `/feeds/requested/landing-pages`,
  },
]

export const getInspirationTabs = ({
  showEmailFeeds = false,
}: {
  showEmailFeeds?: boolean
}) => {
  return showEmailFeeds ? INSPIRATION_TABS : INSPIRATION_TABS.filter((tab) => tab.name !== 'Emails')
}

export const getRequestTabs = ({
  showEmailFeeds = false,
}: {
  showEmailFeeds?: boolean
}) => {
  return showEmailFeeds ? REQUESTS_TABS : REQUESTS_TABS.filter((tab) => tab.name !== 'Emails')
}

export const showTemplateRecentButton = (createdAtString: string) => {
  const createdAt = new Date(createdAtString).getTime()
  const now = Date.now()
  const daysDifference = Math.floor((now - createdAt) / (1000 * 60 * 60 * 24))
  return daysDifference <= 30
}

export const getBrandTabs = ({
  brandID,
  showEmailFeeds = false,
}: {
  brandID: string
  showEmailFeeds?: boolean
}) => {
  const BRAND_TABS = [
    {
      name: 'Ads',
      link: `/feeds/brands/${brandID}`,
      featureName: CreativeOSFeatures.BRANDS_AD_INSPIRATION_NAV_BUTTON,
    },
    {
      name: 'Emails',
      link: `/feeds/brands/${brandID}/emails`,
      featureName: CreativeOSFeatures.BRANDS_EMAIL_INSPIRATION_NAV_BUTTON,
    },
    {
      name: 'Landers',
      link: `/feeds/brands/${brandID}/landing-pages`,
      featureName: CreativeOSFeatures.BRANDS_LANDER_INSPIRATION_NAV_BUTTON,
    },
  ]
  return showEmailFeeds ? BRAND_TABS : BRAND_TABS.filter((tab) => tab.name !== 'Emails')
}
